import { useEffect, useState } from "react";
import { UsersThree, Student, ChalkboardTeacher } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function EspacesEtudiants() {
  const [groups, setGroups] = useState([]);
  useEffect(() => { api.get("/me/groups").then((r) => setGroups(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="student-spaces-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Campus virtuel</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Espaces étudiants</h1>
        <p className="text-sm text-muted-foreground">Vos groupes et vos camarades de promotion.</p>
      </div>

      {groups.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border p-16 text-center text-muted-foreground">
          Vous n'appartenez à aucun groupe pour l'instant.
        </div>
      ) : (
        <div className="space-y-5">
          {groups.map((g) => (
            <div key={g.id} className="rounded-xl border border-border bg-card p-6" data-testid={`space-${g.id}`}>
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary"><UsersThree size={24} weight="duotone" /></div>
                <div>
                  <h3 className="font-display text-xl font-bold">{g.name}</h3>
                  <p className="text-sm text-muted-foreground">{g.description}</p>
                </div>
              </div>
              <p className="mt-4 mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Membres ({g.members.length})</p>
              <div className="flex flex-wrap gap-2">
                {g.members.map((m) => (
                  <div key={m.id} className="flex items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1.5 text-sm">
                    {m.role === "professeur" ? <ChalkboardTeacher size={16} className="text-accent" /> : <Student size={16} className="text-primary" />}
                    {m.name}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
